var _style, _path, _line, _circle, _line2, _circle2, _line3, _circle3, _line4, _circle4, _circle5, _line5, _line6, _circle6, _circle7, _line7, _circle8, _circle9, _circle10, _circle11, _line8, _circle12, _line9, _circle13, _circle14, _circle15, _circle16, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#000000;stroke-width:8.3632;stroke-linecap:round;stroke-miterlimit:136.0544;}\n\t.st2{fill:none;stroke:#000000;stroke-width:4.8485;stroke-linecap:round;stroke-miterlimit:136.0544;}\n\t.st3{fill:none;stroke:#000000;stroke-width:5.4881;stroke-linecap:round;stroke-miterlimit:136.0544;}\n\t.st4{fill:none;stroke:#000000;stroke-width:8.0513;stroke-linecap:round;stroke-miterlimit:136.0544;}\n\t.st5{fill:none;stroke:#000000;stroke-width:6.4115;stroke-linecap:round;stroke-miterlimit:136.0544;}\n\t.st6{fill:none;stroke:#000000;stroke-width:5.3178;stroke-linecap:round;stroke-miterlimit:136.0544;}\n\t.st7{fill:none;stroke:#000000;stroke-width:3.387;stroke-linecap:round;stroke-miterlimit:136.0544;}\n\t.st8{fill:none;stroke:#000000;stroke-width:2.9218;stroke-linecap:round;stroke-miterlimit:136.0544;}\n\t.st9{fill:none;stroke:#000000;stroke-width:5.387;stroke-linecap:round;stroke-miterlimit:136.0544;}\n\t.st10{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.8,1000H144.2C64.56,1000,0,935.44,0,855.8V144.2C0,64.56,64.56,0,144.2,0H855.8 C935.44,0,1000,64.56,1000,144.2V855.8C1000,935.44,935.44,1000,855.8,1000z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 117.35,
    y1: 275.34,
    x2: 270.41,
    y2: 122.28
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.35,
    cy: 275.34,
    r: 30.61
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 117.35,
    y1: 887.59,
    x2: 423.47,
    y2: 581.46
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.35,
    cy: 887.59,
    r: 30.27
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 270.41,
    y1: 122.28,
    x2: 423.47,
    y2: 275.34
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.41,
    cy: 122.28,
    r: 49.24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 270.41,
    y1: 734.52,
    x2: 423.47,
    y2: 887.59
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.41,
    cy: 734.52,
    r: 56.02
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.47,
    cy: 275.34,
    r: 37.85
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 423.47,
    y1: 428.4,
    x2: 747,
    y2: 104.87
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 423.47,
    y1: 428.4,
    x2: 576.53,
    y2: 581.46
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.47,
    cy: 428.4,
    r: 46.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.47,
    cy: 581.46,
    r: 64.47
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 423.47,
    y1: 734.52,
    x2: 576.53,
    y2: 581.46
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.47,
    cy: 734.52,
    r: 48.36
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.47,
    cy: 887.59,
    r: 45.01
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.53,
    cy: 275.34,
    r: 46.49
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.53,
    cy: 581.46,
    r: 59.74
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 729.59,
    y1: 122.28,
    x2: 882.65,
    y2: 275.34
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.59,
    cy: 122.28,
    r: 48.39
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 729.59,
    y1: 275.34,
    x2: 882.65,
    y2: 122.28
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.59,
    cy: 275.34,
    r: 50.68
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 882.65,
    cy: 122.28,
    r: 30.36
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 882.65,
    cy: 275.34,
    r: 68.85
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 882.65,
    cy: 887.59,
    r: 61.55
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    className: "st10",
    width: 900,
    height: 900
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP9);
export default __webpack_public_path__ + "static/media/P9.7ed2890b4dd6251c67cc74049b9f984f.svg";
export { ForwardRef as ReactComponent };